import './ChatError.less';

export type ChatErrorProps = {
    message: string;
};

const ChatError = ({ message }: ChatErrorProps) => (
    <div className={`bri-ChatError`}>{message}</div>
);

export default ChatError;
